import { create } from 'zustand'

export interface Toast {
  id: number
  text: string
  /** an app path the toast opens when tapped */
  to?: string
}

interface ToastState {
  toasts: Toast[]
  show(text: string, opts?: { to?: string; ms?: number }): void
  dismiss(id: number): void
}

let next = 1
const MAX = 3

/** Short-lived, tappable notes that do not take you anywhere until you tap them. */
export const useToasts = create<ToastState>((set, get) => ({
  toasts: [],
  show(text, opts = {}) {
    const id = next++
    set({ toasts: [...get().toasts.slice(-(MAX - 1)), { id, text, ...(opts.to ? { to: opts.to } : {}) }] })
    setTimeout(() => get().dismiss(id), opts.ms ?? 6000)
  },
  dismiss(id) {
    if (get().toasts.some((t) => t.id === id)) set({ toasts: get().toasts.filter((t) => t.id !== id) })
  },
}))
